import { PayinRuntimeStatus } from "@/modules/dashboard/payins/services/paymentsPayin.service";

import type { ActivityDirection } from "../types/paymentsActivity.types";

const MONEY_MOVED = new Set<string>([PayinRuntimeStatus.CONFIRMED, PayinRuntimeStatus.REVERSED]);
const NOTHING_CREDITED = new Set<string>([PayinRuntimeStatus.REJECTED, PayinRuntimeStatus.FAILED]);

export interface AmountRowsView {
  /** Sent by the payer → commission → credited, with how and from whom: only once money really moved. */
  payerView: boolean;
  /** Whatever the entity carries, a rejected or failed payin credited nothing. */
  creditsNothing: boolean;
}

export function amountRowsView(direction: ActivityDirection, status: string): AmountRowsView {
  const isPayin = direction === "payins";
  return {
    payerView: isPayin && MONEY_MOVED.has(status),
    creditsNothing: isPayin && NOTHING_CREDITED.has(status),
  };
}
